import {BaseBlock, theme} from "../../../framework/js/core";
import {ContactForm7} from "../../../plugins/ContactForm7/ContactForm7";

export class WeeklyMenu extends ContactForm7 {
  constructor(root) {
    super(root);
    this.buttons = root.find(".weekly-menu-controls-button");
    
    this.buttons.forEach(button => {
      button.on("click", event => {
        event.preventDefault();
        if (location.href.match(/timestamp=\d+/i)) {
          location.href = location.href.replace(/week-timestamp=[^&#\b]+/i, "week-timestamp=" + button.data("week-timestamp"));
        } else if (location.href.match(/\?/)) {
          location.href = location.href + "&week-timestamp=" + button.data("week-timestamp");
        } else {
          location.href = location.href + "?week-timestamp=" + button.data("week-timestamp");
        }
        // this.loadWeek(button.data("week-timestamp"));
      });
    });
  
    this.disablePopup();
    
    this.subscriptionMessage = root.find(".weekly-menu__sub-form__message");
    
    this.listenFor("successfulRequest", () => {
      console.log("Request successful", this.subscriptionMessage);
      this.subscriptionMessage.removeClass("hidden").addClass("visible");
    });
  }
  
  // loadWeek(timestamp) {
  //   return theme.request("WeeklyMenuController", "getWeeklyMenuPost", {
  //     timestamp: timestamp
  //   }, {
  //     success: data => {
  //       console.log(data);
  //       if (data.menuExists && data.link) {
  //         location.href = data.link;
  //       } else {
  //         this.root.find(".weekly-menu-controls-title .the-week").html(data.weekContent);
  //         this.root.find(".weekly-menu-controls-title .the-date-range").html(data.rangeContent);
  //         this.root.find(".weekly-menu-content.week-full").addClass("hidden");
  //         this.root.find(".weekly-menu-content.week-empty").removeClass("hidden");
  //       }
  //     }
  //   });
  // }
}